export const CoHrId = 'b3dc00a0-810a-4b64-a44e-f98dda9e56d0'
